<template>
  <v-menu v-model="menu" :close-on-content-click="false" left offset-x>
    <template #activator="{ on: onMenu }">
      <v-tooltip :top="!bottom" :bottom="bottom">
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn
            icon
            :loading="loading"
            :disabled="disabled"
            v-on="{ ...onMenu, ...onTooltip }"
          >
            <v-icon>get_app</v-icon>
          </v-btn>
        </template>
        <span>{{ tooltip }} </span>
      </v-tooltip>
    </template>
    <v-list dense>
      <v-list-item style="cursor: pointer; max-height: 26px">
        <v-list-item-title @click="download('uk')"
          >Українською</v-list-item-title
        >
      </v-list-item>
      <v-list-item style="cursor: pointer; max-height: 26px">
        <v-list-item-title @click="download('ru')"
          >Російською</v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import * as downloadFileApi from "@/backend/downloadFileApi.js";
export default {
  props: [
    "location",
    "params",
    "tooltip",
    "filename",
    "extension",
    "bottom",
    "disabled",
  ],
  data: () => ({
    menu: false,
    loading: false,
  }),
  computed: {
    fullName() {
      const fullName = this.filename || "file";
      return this.extension ? `${fullName}.${this.extension}` : fullName;
    },
  },
  methods: {
    download(lang) {
      this.menu = false;
      this.loading = true;
      downloadFileApi
        .download(`${this.location}${lang}`, this.params)
        .then((url) => {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.fullName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },
  },
};
</script>
